/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportExcelStationTransactions$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The start date time of data to filter
 */
  startDate: string;

/**
 * The end date time of data to filter
 */
  endDate: string;
}

export function exportExcelStationTransactions(http: HttpClient, rootUrl: string, params: ExportExcelStationTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportExcelStationTransactions.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportExcelStationTransactions.PATH = '/custom/stations/{uid}/transactions/export';
